import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#050505] border-t border-[#27272A] pt-20 pb-8 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        {/* Massive wordmark */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="pb-10 border-b border-[#27272A]"
        >
          <div className="font-display font-semibold tracking-tighter uppercase leading-[0.85] text-[16vw] md:text-[13vw] text-[#F4F4F5]">
            ENTRETIEN <span className="text-[#E1FF00]">PRO</span> INC
          </div>
          <p className="mt-6 text-[#A1A1AA] max-w-md">{t.footer.tagline}</p>
        </motion.div>

        <div className="pt-10 grid md:grid-cols-4 gap-8 font-mono-acc text-[11px] tracking-[0.15em] uppercase">
          <div>
            <div className="text-[#52525B] mb-3">© {year}</div>
            <div className="text-[#A1A1AA]">Entretien Pro Inc.</div>
            <div className="text-[#A1A1AA]">{t.footer.rights}</div>
          </div>
          <div>
            <div className="text-[#52525B] mb-3">Navigation</div>
            <a href="#services" className="block text-[#F4F4F5] hover:text-[#E1FF00] py-1">{t.nav.services}</a>
            <a href="#manifesto" className="block text-[#F4F4F5] hover:text-[#E1FF00] py-1">{t.nav.manifesto}</a>
            <a href="#quote" className="block text-[#F4F4F5] hover:text-[#E1FF00] py-1">{t.nav.quote}</a>
          </div>
          <div>
            <div className="text-[#52525B] mb-3">Contact</div>
            <a href="mailto:entretienproinc@gmail.com" className="block text-[#F4F4F5] hover:text-[#E1FF00] py-1 normal-case tracking-normal">entretienproinc@gmail.com</a>
            <a href="tel:+15144511361" className="block text-[#F4F4F5] hover:text-[#E1FF00] py-1 normal-case tracking-normal">(514) 451-1361</a>
          </div>
          <div>
            <div className="text-[#52525B] mb-3">Localisation</div>
            <div className="text-[#F4F4F5] normal-case tracking-normal">Grand Montréal, QC</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
